module.exports = __webpack_public_path__ + "static/media/emo1a.81772f3f.png";